import { createSlice } from "@reduxjs/toolkit";

const regionDataSlice = createSlice({
    name: 'regions',
    initialState: {data: {},status: ''},
    reducers: {
        regions(state, action){
            state.data      = action.payload.data
            state.status    = action.payload.status
        },
    },
});

export const regionDataActions = regionDataSlice.actions;
export default regionDataSlice.reducer;